type Coords = {
	lat: number;
	lng: number;
};

type UseGeolocationState = {
	loading: boolean;
	error: GeolocationPositionError | null;
	coords: Coords | null;
};

const ErrorCode = {
	PERMISSION_DENIED: 1,
	POSITION_UNAVAILABLE: 2,
	TIMEOUT: 3,
	NOT_SUPPORTED: 5,
} as const;

export {ErrorCode};
export type {UseGeolocationState};
